import { forwardRef, LegacyRef } from "react";

const GeniusNoAccessScienceSvg = forwardRef(
  (props: React.SVGProps<SVGSVGElement>, ref: LegacyRef<SVGSVGElement>) => {
    return (
      <svg
        ref={ref}
        width="128"
        height="109"
        viewBox="0 0 128 109"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M42.9446 48.3984C35.4879 49.5399 30.6656 49.734 25.3503 52.1761C18.1129 56.5827 11.093 61.6648 6.07467 68.4902C1.0563 75.3155 -1.31797 83.6007 0.741798 91.8198C3.03258 100.967 16.457 108.819 26.3966 108.819C35.2259 108.819 35.9966 108.757 44.8239 108.819H47.0059C47.0059 108.819 46.5652 98.1832 46.8933 94.1862C39.1183 92.9205 31.1413 89.5389 24.6611 85.0585L27.9031 81.0771C27.9031 81.0771 27.6061 86.8056 27.8973 86.8309C37.1342 92.2547 50.3839 96.0964 58.5705 94.3764C61.1486 93.8348 64.3596 93.8931 67.7492 93.8931L72.7015 95.6479V92.3932L76.0309 90.6959C76.0309 90.6959 91.7787 76.6965 87.7487 70.0691C87.7487 70.0691 78.8164 56.7511 74.0622 53.5687C72.115 52.0118 68.7024 50.9628 66.2233 50.6833L49.883 48.8469L42.9446 48.3984Z"
          fill="#F49022"
        />
        <path
          d="M47.0298 94.3432C47.0298 94.3432 53.5934 94.9993 53.6323 94.9935C58.3963 94.1743 63.24 93.8249 68.072 93.9569L74.3988 96.2223L71.8285 105.977L46.7852 106.701L47.0298 94.3432Z"
          fill="#A55D2B"
        />
        <path
          d="M19.9414 82.0312C28.0329 88.1364 37.5688 92.1315 47.59 94.3367C49.9448 94.855 52.3676 95.0025 54.7671 94.7676C59.3099 94.3231 63.8274 93.7271 67.7508 93.8941C69.5136 94.4066 72.346 95.5966 74.1087 96.109"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M68.3242 96.2344C70.0287 96.8633 71.7313 97.4942 73.4358 98.1232"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M72.8308 100.517C70.8526 99.702 68.4841 98.8848 66.6127 97.9083C66.5797 97.8093 66.5467 97.7103 66.5156 97.6094"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M71.7633 104.045C69.1484 103.039 66.5314 102.035 64.0077 101.034C63.8931 100.744 63.7786 100.453 63.6641 100.164"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.5586 85.0133C26.6125 82.4411 28.6665 79.869 30.7224 77.2969"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.947 80.7734C27.9217 82.5167 27.9237 85.3897 27.8984 87.1329"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51.18 78.5234C48.3302 83.3105 43.2574 85.1061 38.3672 84.0268"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M68.75 60.1562C71.4077 63.4699 74.1275 66.9059 75.2787 70.9941C76.43 75.0824 75.6146 80.0364 72.2114 82.5774L72.3687 95.3313"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.888 94.1797L46.7812 105.944"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.4744 35.6317C49.114 35.9203 50.6772 34.8252 50.9658 33.1856C51.2544 31.5461 50.1592 29.9831 48.5196 29.6944C46.88 29.4058 45.3168 30.501 45.0282 32.1405C44.7396 33.78 45.8348 35.3431 47.4744 35.6317Z"
          fill="black"
        />
        <path
          d="M44.6335 49.447C45.1239 46.2546 47.4339 32.2033 47.4339 32.2033C45.702 32.5154 44.14 32.1143 42.9464 30.8204C41.7529 29.5265 41.9159 28.8906 42.3658 27.1872C42.815 25.4872 42.961 24.0576 44.637 23.521L53.5703 16.5523C55.9249 15.8591 58.5494 16.1302 60.7138 17.2917C62.8782 18.4531 64.1137 18.5141 64.8358 20.86C65.6123 25.1307 62.8523 34.8253 62.8523 34.8253C61.9041 37.385 59.5744 39.5631 56.8763 39.9811C56.7228 40.2336 56.0295 44.2104 56.0295 44.2104L55.0405 51.0675C54.2057 51.4148 52.2186 52.1113 49.6845 51.7335C47.0638 51.3437 45.3258 50.0255 44.6412 49.4415L44.6335 49.447Z"
          fill="#A55D2B"
        />
        <path
          d="M52.9084 21.8453C54.5984 20.6613 55.4198 18.9187 54.7433 17.9531C54.0667 16.9875 52.1482 17.1645 50.4583 18.3485C48.7684 19.5324 47.9469 21.275 48.6235 22.2406C49.3001 23.2062 51.2185 23.0292 52.9084 21.8453Z"
          fill="black"
        />
        <path
          d="M44.9336 27.2656C45.6481 27.7765 46.1965 28.5138 46.4831 29.3448"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.443 26.1225C46.5747 24.6268 42.8518 24.4384 42.2419 27.9029C41.8013 30.4055 43.9154 32.918 47.2064 32.1714"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.6808 38.9847C52.909 40.0551 55.553 40.4285 57.8579 39.6106C58.4359 39.4056 59.0036 39.1238 59.5443 38.7827C61.7296 37.4053 62.7859 35.6452 63.404 32.7342C64.0221 29.8233 65.9893 21.3592 64.3805 20.3331"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.9297 25.5781C49.0367 26.4342 49.054 28.3493 47.966 29.2245C48.723 29.126 49.5065 29.69 49.6537 30.4418C49.8008 31.1937 49.2856 32.0096 48.546 32.2032C49.1718 32.6371 49.521 33.4416 49.4126 34.1928C49.3042 34.944 48.7423 35.6188 48.0188 35.8561"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.5208 38.9814C51.7837 41.1975 53.7413 43.0111 56.0471 44.1054C56.0471 44.1054 56.6621 40.3794 56.7267 40.0124C54.6677 40.3044 52.5023 39.8073 50.5241 38.982L50.5208 38.9814Z"
          fill="black"
        />
        <path
          d="M45.3102 33.3049C46.0241 33.4305 46.7047 32.9537 46.8304 32.2398C46.9561 31.526 46.4792 30.8454 45.7653 30.7197C45.0514 30.5941 44.3708 31.0709 44.2451 31.7848C44.1194 32.4986 44.5963 33.1792 45.3102 33.3049Z"
          fill="#FDE7C7"
        />
        <path
          d="M59.7434 32.0258C59.2632 31.4811 58.9477 30.7951 58.8305 30.028C58.6987 29.1698 58.8529 28.2938 59.2139 27.5018C59.4313 27.022 59.6851 26.6066 59.9976 26.2253C61.3142 24.6132 63.8056 24.8848 64.4912 26.4505"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M57.8831 24.1655C56.37 23.1187 54.2272 23.4027 52.9293 24.541"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M62.0927 29.6951C62.5528 29.7761 63.0103 29.3622 63.1144 28.7706C63.2185 28.1791 62.93 27.6339 62.4698 27.5529C62.0097 27.4719 61.5523 27.8858 61.4482 28.4773C61.344 29.0689 61.6326 29.6141 62.0927 29.6951Z"
          fill="black"
        />
        <path
          d="M52.5122 30.1829L56.3502 32.8932C56.3502 32.8932 54.5611 34.2074 53.1789 33.3268C52.3328 32.7893 51.7043 31.2677 52.5149 30.1868L52.5122 30.1829Z"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.4404 28.5232C55.9005 28.6042 56.3579 28.1903 56.462 27.5988C56.5662 27.0072 56.2776 26.462 55.8175 26.381C55.3574 26.3 54.9 26.7139 54.7958 27.3055C54.6917 27.897 54.9803 28.4422 55.4404 28.5232Z"
          fill="black"
        />
        <path
          d="M56.7773 39.8906L55.1134 50.5143"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M64.9309 20.859C65.3988 20.0791 66.3285 19.9291 67 20.0644C67.6715 20.1996 68.177 20.8714 68.1686 21.5584C68.1601 22.2454 67.6664 22.881 67.0192 23.1113C67.3946 22.7991 68.0264 22.8694 68.3264 23.2562C68.6264 23.643 68.5363 24.2713 68.1379 24.5591C68.8792 24.0659 69.9799 24.2221 70.5554 24.9028C71.1309 25.5835 71.0987 26.6958 70.4874 27.3414"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M54.4207 11.2624C54.9971 11.2411 55.4983 10.6784 55.4528 10.1046C55.4072 9.53078 54.8305 9.05094 54.2565 9.11691C55.4042 8.83156 56.4271 7.90051 56.5955 6.73046C56.764 5.56041 55.8855 4.27764 54.7051 4.20619"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.3376 3.84416C41.7557 3.14187 40.7147 2.85979 39.8586 3.17262C39.0026 3.48546 38.3896 4.37278 38.4023 5.28842C37.8572 4.89937 37.1169 4.80655 36.491 5.05085C35.8652 5.29514 35.3832 5.86468 35.2442 6.51847"
          stroke="black"
          strokeWidth="0.472168"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.5967 25.0997C47.1945 25.8786 47.3147 25.4669 47.3248 26.4162C47.8553 26.772 48.5838 26.5253 48.7858 25.9201C49.1313 24.8869 49.5568 23.67 50.2752 22.0481C50.8798 20.6855 52.1184 19.6902 53.5888 19.431C57.3454 18.7698 61.5991 19.0993 65.0903 21.2817C65.3097 15.7955 61.5189 12.5652 57.172 11.0809C52.8251 9.59662 47.6835 10.7672 44.4097 13.9912C41.1358 17.2151 38.2748 23.2826 42.2403 29.1408C42.2415 28.1662 42.2902 26.515 43.3318 25.8258C44.3734 25.1366 45.1357 24.872 45.6033 25.1009L45.5967 25.0997Z"
          fill="black"
        />
        <path
          d="M54.4716 11.4915C54.7345 11.1016 54.7543 10.5631 54.5274 10.1483C54.3005 9.73342 53.8321 9.47034 53.37 9.36515C54.0566 8.81458 54.3269 7.80218 54.0043 6.98195C53.6817 6.16172 52.795 5.60346 52.0097 5.90149C52.1606 5.39295 52.0444 4.81355 51.7121 4.39719C51.3798 3.98083 50.8383 3.74578 50.4975 3.90051C50.337 3.16674 49.7843 2.53094 49.0802 2.27069C48.3762 2.01043 47.5434 2.13309 47.2163 2.53904C46.4578 1.83294 45.3284 1.54895 44.3238 1.81518C43.3192 2.08141 42.4763 2.88056 42.2362 3.79941C41.5791 3.40769 40.6942 3.43937 40.0628 3.87014C39.4313 4.30092 39.0867 5.11618 39.1384 5.81033C38.4153 5.69669 37.6425 6.02077 37.2177 6.61401C36.7928 7.20725 36.7339 8.04553 37.102 8.64543C36.5094 8.7013 35.9625 9.11628 35.7549 9.67618C35.5473 10.2361 35.6846 10.9078 36.2761 11.2846C35.649 11.7298 35.4007 12.637 35.71 13.339C36.0193 14.041 36.8582 14.4647 37.6281 14.1572C36.993 14.6282 36.7532 15.5641 37.0866 16.284C37.42 17.0039 38.2821 17.4317 39.1271 17.1817C39.1354 18.025 39.6804 18.8401 40.4572 19.1711C41.234 19.5021 42.1986 19.3277 42.8121 18.7472L54.4716 11.4915Z"
          fill="black"
        />
        <path
          d="M46.6572 25.2001C46.6095 21.4052 49.3565 16.7013 53.7174 15.8602C56.8577 15.2542 61.2095 15.1034 64.318 17.0206C63.0993 14.3011 61.3443 12.7311 59.2049 12.3375C55.1782 11.6287 51.8408 11.8831 48.9116 13.9816C45.9824 16.0801 43.4533 20.611 43.6716 25.3733C44.5091 24.914 45.75 24.6417 46.6605 25.2007L46.6572 25.2001Z"
          fill="#F8BC7A"
        />
        <path
          d="M41.8953 49.1804L42.1224 45.7309C42.2001 44.5448 43.2251 43.6441 44.4132 43.7236L56.7738 44.5351C57.9599 44.6127 58.8607 45.6377 58.7811 46.8257L58.554 50.2753C58.4763 51.4614 57.4513 52.3621 56.2632 52.2825L43.9027 51.4711C42.7165 51.3934 41.8176 50.3685 41.8953 49.1804Z"
          fill="#F49022"
        />
        <path
          d="M56.9391 50.2935C52.6041 50.3323 48.2671 49.9344 44.0117 49.1094"
          stroke="black"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.9808 77.3438C30.4217 80.8574 29.7927 84.3691 29.2336 87.8827L27.8125 86.9412L28.0862 80.7545L30.9808 77.3438Z"
          fill="black"
        />
        <path
          d="M41.6133 48.5234C41.9996 52.9358 45.8668 56.7853 50.2833 57.1483C54.6999 57.5113 58.1807 54.1918 59.2814 49.9017"
          stroke="#F8BC7A"
          strokeWidth="0.472168"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M87.7539 108.897H33.1934V107.898C33.1934 106.073 34.6729 104.594 36.4976 104.594H87.7539V108.897Z"
          fill="black"
        />
        <path
          d="M66.5871 108.896H116.199L127.099 75.9484C128.152 72.7644 125.781 69.4844 122.429 69.4844H83.1803C81.0585 69.4844 79.1768 70.8437 78.5106 72.8574L66.5871 108.896Z"
          fill="black"
        />
        <path
          d="M96.7298 90.6591C96.2865 88.7816 97.4492 86.9002 99.3268 86.4569C101.204 86.0135 103.086 87.1762 103.529 89.0537C103.973 90.9312 102.81 92.8125 100.932 93.2559C99.0547 93.6992 97.1732 92.5366 96.7298 90.6591Z"
          fill="white"
        />
        <path
          d="M100.159 93.9309C102.35 93.9309 104.133 92.1483 104.133 89.9576C104.133 87.7669 102.35 85.9844 100.159 85.9844C97.9685 85.9844 96.1858 87.7669 96.1858 89.9576C96.1888 92.1483 97.9685 93.9309 100.159 93.9309ZM100.159 86.9446C101.822 86.9446 103.175 88.2981 103.175 89.9606C103.175 91.6232 101.822 92.9765 100.159 92.9765C98.4967 92.9765 97.1432 91.6232 97.1432 89.9606C97.1462 88.2951 98.4967 86.9446 100.159 86.9446Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default GeniusNoAccessScienceSvg;
